// extracted by mini-css-extract-plugin
export default {"container":"S05_container__Lz40H","limiter":"S05_limiter__kMn3v","text":"S05_text__mnIOl"};